import { render, staticRenderFns } from "./project_list.vue?vue&type=template&id=423ee1b0&scoped=true&"
import script from "./project_list.vue?vue&type=script&lang=js&"
export * from "./project_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423ee1b0",
  null
  
)

export default component.exports